export default function StatCard({ title, value, icon: Icon, color }) {
  return (
    <div
      style={{
        background: '#ffffff',
        borderRadius: '12px',
        padding: '24px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        borderLeft: color ? `4px solid ${color}` : '4px solid #6B8063',
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
      }}
    >
      {Icon && (
        <div
          style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: color
              ? `${color}15`
              : 'rgba(107, 128, 99, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon size={22} color={color || '#6B8063'} />
        </div>
      )}
      <div>
        <div
          style={{
            fontSize: '1.75rem',
            fontWeight: 700,
            color: '#2B362E',
            lineHeight: 1.2,
          }}
        >
          {value}
        </div>
        <div
          style={{
            fontSize: '0.85rem',
            color: '#6b6b6b',
            marginTop: '2px',
          }}
        >
          {title}
        </div>
      </div>
    </div>
  );
}
